async function getLastPayment(paymentRepository, nick) {
    return await paymentRepository.getLastPayment(nick)
}

async function getLastPaymentV8(paymentRepository, nick) {
    return await paymentRepository.getLastPaymentV8(nick)
}

export {getLastPayment, getLastPaymentV8}